import styled, { css, keyframes } from 'styled-components';
import { pxToRem } from '../../../foundation/spacing/utils.js';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';

var BACKGROUND_COLOR_KEY = '--tooltip-background-color';
var TRIANGLE_SIZE = 6;
var TRIANGLE_SIZE_HALF = TRIANGLE_SIZE / 2;
var TOOLTIP_DISTANCE = 10;
var triangleBaseStyles = css(["content:'';display:block;position:absolute;width:0;height:0;border-style:solid;border-width:0 ", " ", " ", ";border-color:transparent transparent var(", ") transparent;"], pxToRem(TRIANGLE_SIZE), pxToRem(TRIANGLE_SIZE), pxToRem(TRIANGLE_SIZE), BACKGROUND_COLOR_KEY);
var slideInTop = keyframes(["0%{opacity:0;transform:translateY(0);}100%{opacity:1;transform:translateY(-", ");}"], pxToRem(TOOLTIP_DISTANCE));
var slideInBottom = keyframes(["0%{opacity:0;transform:translateY(0);}100%{opacity:1;transform:translateY(", ");}"], pxToRem(TOOLTIP_DISTANCE));
var slideInLeft = keyframes(["0%{opacity:0;transform:translateX(0);}100%{opacity:1;transform:translateX(-", ");}"], pxToRem(TOOLTIP_DISTANCE));
var slideInRight = keyframes(["0%{opacity:0;transform:translateX(0);}100%{opacity:1;transform:translateX(", ");}"], pxToRem(TOOLTIP_DISTANCE));
var getFixedWidthStyles = function getFixedWidthStyles(width) {
  if (width === undefined) {
    return undefined;
  }
  return css(["max-width:", ";"], pxToRem(width));
};
var getTextColor = function getTextColor(appearance) {
  switch (appearance) {
    case 'light':
      return css(["color:", ";"], themeGet('colors.gray.1000'));
    case 'primary':
    default:
      return css(["color:", ";"], themeGet('colors.gray.0'));
  }
};
var getBackgroundColor = function getBackgroundColor(appearance) {
  switch (appearance) {
    case 'light':
      return themeGet('colors.gray.0');
    case 'primary':
    default:
      return themeGet('colors.gray.1000');
  }
};
var getTriangleStyles = function getTriangleStyles(position) {
  switch (position) {
    case 'top':
      return css(["&:after{", ";transform:rotate(180deg);top:100%;left:calc(50% - ", ");}"], triangleBaseStyles, pxToRem(TRIANGLE_SIZE));
    case 'top-end':
      return css(["&:after{", ";transform:rotate(180deg);top:100%;right:", ";}"], triangleBaseStyles, themeGet('spacing.md'));
    case 'top-start':
      return css(["&:after{", ";transform:rotate(180deg);top:100%;left:", ";}"], triangleBaseStyles, themeGet('spacing.md'));
    case 'bottom':
      return css(["&:after{", ";bottom:100%;left:calc(50% - ", ");}"], triangleBaseStyles, pxToRem(TRIANGLE_SIZE));
    case 'bottom-end':
      return css(["&:after{", ";bottom:100%;right:", ";}"], triangleBaseStyles, themeGet('spacing.md'));
    case 'bottom-start':
      return css(["&:after{", ";bottom:100%;left:", ";}"], triangleBaseStyles, themeGet('spacing.md'));
    case 'left':
      return css(["&:after{", ";transform:rotate(90deg);left:calc(100% - ", ");top:calc(50% - ", ");}"], triangleBaseStyles, pxToRem(TRIANGLE_SIZE_HALF), pxToRem(TRIANGLE_SIZE_HALF));
    case 'left-end':
      return css(["&:after{", ";transform:rotate(90deg);left:calc(100% - ", ");bottom:", ";}"], triangleBaseStyles, pxToRem(TRIANGLE_SIZE_HALF), themeGet('spacing.md'));
    case 'left-start':
      return css(["&:after{", ";transform:rotate(90deg);left:calc(100% - ", ");top:", ";}"], triangleBaseStyles, pxToRem(TRIANGLE_SIZE_HALF), themeGet('spacing.md'));
    case 'right':
      return css(["&:after{", ";transform:rotate(-90deg);right:calc(100% - ", ");top:calc(50% - ", ");}"], triangleBaseStyles, pxToRem(TRIANGLE_SIZE_HALF), pxToRem(TRIANGLE_SIZE_HALF));
    case 'right-end':
      return css(["&:after{", ";transform:rotate(-90deg);right:calc(100% - ", ");bottom:", ";}"], triangleBaseStyles, pxToRem(TRIANGLE_SIZE_HALF), themeGet('spacing.md'));
    case 'right-start':
      return css(["&:after{", ";transform:rotate(-90deg);right:calc(100% - ", ");top:", ";}"], triangleBaseStyles, pxToRem(TRIANGLE_SIZE_HALF), themeGet('spacing.md'));
    default:
      return undefined;
  }
};
var getPositionStyles = function getPositionStyles(position) {
  switch (position) {
    case 'top':
    case 'top-end':
    case 'top-start':
      return css(["transform:translateY(-", ");animation:", " 200ms forwards cubic-bezier(0,0,0,1);"], pxToRem(TOOLTIP_DISTANCE), slideInTop);
    case 'bottom':
    case 'bottom-end':
    case 'bottom-start':
      return css(["transform:translateY(", ");animation:", " 200ms forwards cubic-bezier(0,0,0,1);"], pxToRem(TOOLTIP_DISTANCE), slideInBottom);
    case 'left':
    case 'left-end':
    case 'left-start':
      return css(["transform:translateX(-", ");animation:", " 200ms forwards cubic-bezier(0,0,0,1);"], pxToRem(TOOLTIP_DISTANCE), slideInLeft);
    case 'right':
    case 'right-end':
    case 'right-start':
      return css(["transform:translateX(", ");animation:", " 200ms forwards cubic-bezier(0,0,0,1);"], pxToRem(TOOLTIP_DISTANCE), slideInRight);
    default:
      return undefined;
  }
};
var Content = styled.div.withConfig({
  displayName: "Content",
  componentId: "sc-8a335g-0"
})(["", ":", ";position:relative;padding:", " ", ";font-size:", ";border-radius:", ";background-color:var(", ");", ";", " ", ";", ";"], BACKGROUND_COLOR_KEY, function (props) {
  return getBackgroundColor(props.$appearance);
}, themeGet('spacing.sm'), themeGet('spacing.md'), themeGet('fontSize.small'), themeGet('spacing.sm'), BACKGROUND_COLOR_KEY, function (props) {
  return getTextColor(props.$appearance);
}, function (props) {
  return getPositionStyles(props.$position);
}, function (props) {
  return getTriangleStyles(props.$position);
}, function (props) {
  return getFixedWidthStyles(props.$width);
});

export { Content };
